export default "__VITE_ASSET__DgoPHyyF__"